import menu from './menu';
import registeredGroups from './registered-groups';

export default {
  menu,
  registeredGroups,
};
